<template>
  <span
    v-tippy="{ arrow: true, theme: 'green' }"
    :content="positionDict.tooltip"
    class="bg-ontick-yellow-800 text-ontick-graphite-500 flex h-4 w-4 items-center justify-center rounded-sm text-[10px] font-semibold"
  >
    {{ positionDict.text }}
  </span>
</template>

<script>
export default {
  props: {
    position_status: {
      type: String,
    },
  },
  computed: {
    positionDict() {
      switch (this.position_status) {
        case "Comprado":
        case "BUY":
          return {
            text: "C",
            tooltip: "Comprado",
          };
        case "Vendido":
        case "SELL":
          return {
            text: "V",
            tooltip: "Vendido",
          };
        default:
          return {
            text: "-",
            tooltip: "Zerado",
          };
      }
    },
  },
};
</script>

<style></style>
